import { useMemo } from 'react';
import { Typography } from '../../../../core/components/molecules/Typography';
import useWeekChart from '../../hooks/use-week-chart';
import { getDayOfWeek, getWeeksOfCurrentMonth } from '../../utils/week';
import MemoryCard from '../card';
import GradientBarChart from '../gradient-bar-chart';
import Select from '../select';
import * as echarts from 'echarts/core';

const ScheduledReviews = ({ style }: { style?: React.CSSProperties }) => {
  const emptyBar = { colorFrom: '#E6EBF0', colorTo: '#E6EBF0' };

  const { data, setWeek, week } = useWeekChart();

  const weeks = getWeeksOfCurrentMonth();

  const isNotData = useMemo(() => {
    return Object.values(data).every((value) => value === 0);
  }, [data]);

  const items = useMemo(() => {
    const daysOfWeek = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'];

    const response = daysOfWeek.map((day) => ({
      label: day,
      ...emptyBar,
      value: isNotData ? 100 : 0,
    }));

    for (const day in data) {
      const dayOfWeek = getDayOfWeek(day);
      const index = daysOfWeek.indexOf(dayOfWeek);
      response[index].value = data[day] || 0;
      response[index].colorFrom = '#00B8AB';
      response[index].colorTo = '#84D9B2';
    }

    return {
      tooltip: {
        show: !isNotData,
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      dataset: {
        dimensions: ['label', 'Flashcards'],
        source: response.map((item) => ({
          label: item.label,
          Flashcards: item.value,
        })),
      },
      xAxis: { type: 'category', splitLine: false, axisLine: false },
      yAxis: {
        type: 'value',
        splitLine: false,
        axisLine: false,
        axisLabel: false,
      },
      series: [
        {
          type: 'bar',
          itemStyle: {
            barBorderRadius: 50,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: isNotData ? emptyBar.colorTo : '#84D9B2' },
              { offset: 1, color: isNotData ? emptyBar.colorFrom : '#00B8AB' },
            ]),
          },
        },
      ],
    };
  }, [data, isNotData]);

  return (
    <div
      className='flex w-full flex-col gap-2'
      style={{
        ...style,
      }}
    >
      <div className='flex h-[45px] flex-row items-center justify-between gap-2'>
        <Typography className='text-h5 font-bold !text-mono-color-darker'>
          Revisões Agendadas
        </Typography>
        <Select
          options={weeks.map((week, index) => ({
            label: `Semana ${index + 1} (${week.start} a ${week.end})`,
            value: week.week,
          }))}
          value={week}
          onChange={(value) => setWeek(value as number)}
        />
      </div>
      <MemoryCard className='flex h-[250px] flex-row items-center justify-center'>
        <GradientBarChart options={items} />
      </MemoryCard>
    </div>
  );
};

export default ScheduledReviews;
